import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router'

export default function GlossarySection() {
  return (
    <div
  className="p-4 p-md-5 mb-2 mt-5"
  style={{
    textAlign: "center",
    background: "#f8f9fa",
    borderRadius: "16px",
    maxWidth: "1200px",
    margin: "0 auto"
  }}
>
  <Row className="align-items-center">
    <Col xs="12" md="7" style={{ textAlign: "left" }}>
      <h2 className="mb-3">New to investing? Start with the glossary.</h2>
      <p className="mb-3">
        The stock market can feel overwhelming when you keep hearing terms like
        ETF, dividend yield, market cap, expense ratio, and bull market.
        The Stocks With Nik glossary breaks these terms down in plain English so
        beginners can learn the basics without all the jargon.
      </p>
      <p className="mb-4">
        It’s a simple place to build your foundation, understand what you’re
        seeing in videos and articles, and grow your confidence as an investor.
      </p>

      <div className="d-flex flex-wrap gap-2 justify-content-center justify-content-md-start">
        <Link to="/stock-market-glossary">
          <Button>Explore the Glossary</Button>
        </Link>

        <Link to="/quiz">
          <Button variant="outline-primary">Build My Portfolio</Button>
        </Link>
      </div>
    </Col>

    <Col xs="12" md="5" className="mt-4 mt-md-0">
      <div
        style={{
          background: "#ffffff",
          borderRadius: "14px",
          padding: "24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          textAlign: "left",
          maxWidth: "420px",
          margin: "0 auto"
        }}
      >
        <h4 className="mb-3">Popular beginner terms</h4>
        <ul className="mb-0 ps-3">
          <li className="mb-2"><strong>ETF</strong> — a basket of investments that trades like a stock</li>
          <li className="mb-2"><strong>Dividend Yield</strong> — how much income an investment pays relative to price</li>
          <li className="mb-2"><strong>Market Cap</strong> — the size of a company based on its total value</li>
          <li className="mb-2"><strong>Expense Ratio</strong> — the annual fee charged by a fund</li>
          <li><strong>Diversification</strong> — spreading your money across investments to reduce risk</li>
        </ul>
      </div>
    </Col>
  </Row>
</div>
  )
}
